import React from "react";
import PropTypes from "prop-types";
import Typography from "material-ui/Typography";
import classNames from "classnames";
import BarLoader from "../../../../../Parts/BarLoader";

// 共通のキーマン行コンポーネント
export const KeymanRow = ({
  item,
  index,
  classes,
  isClickable,
  onItemClick,
}) => (
  <div
    className={classNames(classes.row, isClickable ? classes.isEnable : "")}
    key={index}
    onClick={() => isClickable && onItemClick(item)}
  >
    <div className={classes.logo}>
      <img src={item.logo_path} alt="logo" className={classes.logoImg} />
    </div>
    <div className={classes.textContainer}>
      <Typography
        variant="subheading"
        className={classes.text}
        title={`${item.name} 様`}
      >
        {`${item.name} 様`}
      </Typography>
      <Typography
        variant="body1"
        className={classes.text}
        title={item.honorific}
      >
        {item.company_name} {item.honorific}
      </Typography>
    </div>
  </div>
);

KeymanRow.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
  isClickable: PropTypes.bool.isRequired,
  onItemClick: PropTypes.func.isRequired,
};

// 共通のキーマンリストコンポーネント
export const KeymanList = ({
  classes,
  isLoading,
  list,
  total,
  displayCount = 5, // eslint-disable-line no-magic-numbers
  title,
  searchButtonText,
  isClickable,
  onItemClick,
  onSearchClick,
}) => {
  const renderContent = () => {
    if (isLoading && list.length === 0) {
      return (
        <div className={classes.emptyContainer}>
          <BarLoader type="dark" size="large" width={200} />
        </div>
      );
    }

    if (list.length === 0) {
      return (
        <div className={classes.emptyContainer}>
          該当するキーマンはまだいません。
        </div>
      );
    }

    return (
      <div className={classes.rowWrap}>
        {list.map((item, i) => (
          <KeymanRow
            key={i}
            item={item}
            index={i}
            classes={classes}
            isClickable={isClickable}
            onItemClick={onItemClick}
          />
        ))}
        {/* レイアウト調整用の空の行 */}
        <div className={classes.row} style={{ padding: 0 }}></div>
        <div className={classes.row} style={{ padding: 0 }}></div>

        {total > displayCount + 1 && isClickable && (
          <div className={classes.showAll}>
            <a onClick={onSearchClick}>{searchButtonText}</a>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <div
        className={classes.section}
        style={{ paddingBottom: isLoading ? "60px" : "30px" }}
      >
        <div className={classes.titleContainer}>
          <div className={classes.title}>{title}</div>
        </div>
        {renderContent()}
      </div>
    </div>
  );
};

KeymanList.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  list: PropTypes.array,
  total: PropTypes.number,
  displayCount: PropTypes.number,
  title: PropTypes.string.isRequired,
  searchButtonText: PropTypes.string.isRequired,
  isClickable: PropTypes.bool.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onSearchClick: PropTypes.func.isRequired,
};

KeymanList.defaultProps = {
  isLoading: false,
  list: [],
  total: 0,
  displayCount: 5, // eslint-disable-line no-magic-numbers
};



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/sections/shared/KeymanList.jsx